import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BriefConfigService } from "../../services/briefConfigService";

export function useCreateScripting() {
  const {
    mutate: createScripting,
    isLoading: isCreating,
    isSuccess: isCreated,
    isError,
    data,
  } = useMutation({
    mutationFn: (briefId: string) =>
      BriefConfigService.creatScript(briefId).catch(async (err) => {
        const responseBody = await err.response?.json?.();
        if (responseBody?.msg) ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {},
  });

  return { createScripting, isCreating, isCreated, isError, data };
}
